import * as S from './NativoToutStyles';

interface NativoPlaceholderProps {
  className?: string;
}

const NativoPlaceholder = ({ className }: NativoPlaceholderProps) => {
  return (
    <ul className={className}>
      <div>
        <S.ImagePlaceholder>
          <S.GrayPlaceholder />
        </S.ImagePlaceholder>
        <S.NativoEyebrow>Paid Content</S.NativoEyebrow>
      </div>
    </ul>
  );
};

export default NativoPlaceholder;
